export const orderByArray = function(data,column,desc=true,isNumber=true,date=false){
  data.sort(function(a,b){
    if(!isNumber && !date){
      var atitle;
      var btitle;
      try {
        atitle = a[column].toString().trim();
        btitle = b[column].toString().trim();
      } catch (error) {
        atitle="0";
        btitle="0";
      }
      var alfabe = "0123456789AaBbCcÇçDdEeFfGgĞğHhIıİiJjKkLlMmNnOoÖöPpQqRrSsŞşTtUuÜüVvWwXxYyZz";
      if (atitle.length === 0 || btitle.length === 0) {
          return atitle.length - btitle.length;
      }
      for (var i = 0; i < atitle.length && i < btitle.length; i++) {
          var ai = alfabe.indexOf(atitle[i].toUpperCase());
          var bi = alfabe.indexOf(btitle[i].toUpperCase());
          if (ai !== bi) {
              if(desc){
                return bi - ai;
              }else{
                return ai - bi;
              }
          }
      }
    }
    if(isNumber && !date){
      if(desc){
        return b[column]-a[column];
      }else{
        return a[column]-b[column];
      }
    }
    if(date){
      if(desc){
        return new Date(b[column])-new Date(a[column]);
      }else{
        return new Date(a[column])-new Date(b[column]);
      }
    }
  });
return data;
}